module.exports = __webpack_public_path__ + "img/Logo_viv_nl.52800b7a.png";